import { render, staticRenderFns } from "./FormResponseErrors.vue?vue&type=template&id=c8bf57fa&"
import script from "./FormResponseErrors.vue?vue&type=script&lang=js&"
export * from "./FormResponseErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports